module.exports = __webpack_public_path__ + "assets/img/嘉立创.9684d533.jpg";